import { render } from "./ReportTableSection.vue?vue&type=template&id=c1005fb2&scoped=true"
import script from "./ReportTableSection.vue?vue&type=script&lang=js"
export * from "./ReportTableSection.vue?vue&type=script&lang=js"

import "./ReportTableSection.vue?vue&type=style&index=0&id=c1005fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1005fb2"]])

export default __exports__